export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13537.28a28584.jpg";